import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=448ba9f6&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=448ba9f6&prod&lang=scss&"
import style1 from "./DefaultLayout.vue?vue&type=style&index=1&id=448ba9f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports